import { 
    apiRequest,
    strukturOrganisasiCreate,
 } from '../../../../../services/adapters/base'


class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest('post', strukturOrganisasiCreate, {
            body: query
        }, true)
    }
 
}

export default CreateRepository
